import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AvForm, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import "react-image-lightbox/style.css";
import { toast } from "react-toastify";
import { Button, CardBody, CardHeader, Input } from "reactstrap";
import { apiSiteAuthenticationDetailsGet, apiSiteAuthenticationDetailsSave, CurrentUserRole } from "../../api/auth";
import { apiSiteSettingsForSiteList } from "../../api/site";
import { usersForSiteGetList } from "../../api/users";
import { tableIcons } from "../../helpers/tableIcons";
import { RoleToDisplayRole } from "../../helpers/utils";
import local from "../../localization/strings";

const ConfigureMfa = ({ site, cancel, showCard = true }) => {
	const [data, setData] = useState(undefined);
	const [users, setUsers] = useState(undefined);
	const [loading, setLoading] = useState(true);
	const [selected, setSelected] = useState([]);
	const [userRole, setUserRole] = useState("");
	const [siteSettings, setSiteSettings] = useState([]);

	useEffect(() => {
		const LoadData = async () => {
			setLoading(true);
			setUserRole(CurrentUserRole());
			var result = await apiSiteAuthenticationDetailsGet(site.id);

			setData({ mfaEnabled: result.some((x) => x.detail === "MFA" && !x.userId && x.isEnabled) ? 1 : 0 });

			const workingSelected = [];
			result.forEach((x) => {
				if (x.userId && x.detail === "MFABypass" && x.isEnabled) {
					workingSelected.push(x.userId);
				}
			});
			setSelected(workingSelected);

			setSiteSettings(await apiSiteSettingsForSiteList(site.id));
			setUsers(await usersForSiteGetList(site.id));
			setLoading(false);
		};

		LoadData();
	}, [site.id]);

	async function save(_e, values) {
		//Make sure the DHSiteAdmin(s) has Bypass Set
		if (values.mfaEnabled === 1) {
			siteSettings
				.filter((x) => x.settingKey === "DHSiteAdmin")
				.forEach((ss) => {
					if (!selected.some((x) => x.toUpperCase() === ss.settingValue.toUpperCase())) {
						selected.push(ss.settingValue.toUpperCase());
					}
				});
		}

		await apiSiteAuthenticationDetailsSave(site.id, values.mfaEnabled === 1, selected);

		toast.success(local.TS_Update_Successful);

		cancel();
	}

	const checkedChanged = (siteId) => {
		if (selected.includes(siteId)) {
			setSelected(selected.filter((x) => x !== siteId));
		} else {
			setSelected([...selected, siteId]);
		}
	};

	const columns = [
		{
			title: local.TF_Assigned,
			render: (rowData) => {
				if (siteSettings.some((x) => x.settingKey === "DHSiteAdmin" && x.settingValue.toUpperCase() === rowData.id.toUpperCase())) {
					return <FontAwesomeIcon icon="question-circle" style={{ "marginLeft": "-1.55rem", "cursor": "pointer" }} className="text-danger" title={local.TF_MFA_DHub} />;
				} else {
					return <Input type="checkbox" className="pin-button" checked={selected.includes(rowData.id.toUpperCase())} onChange={() => checkedChanged(rowData.id.toUpperCase())} />;
				}
			},
		},
		{ field: "displayName", title: local.TS_Name, defaultSort: "asc" }, //
		{ field: "role", title: local.TS_Type, render: (rowData) => <span>{RoleToDisplayRole(rowData.role)}</span> },
		{ field: "email", title: local.TS_Email },
	];

	return (
		<div className={showCard ? "card p-3" : ""}>
			<CardHeader>
				<h5 className="text-primary">
					{local.TF_Site}: {site.displayName}
				</h5>
				<h5>{local.TF_MFA}</h5>
			</CardHeader>
			<CardBody>
				{!loading && data && (
					<AvForm model={data} onValidSubmit={async (e, values) => await save(e, values)}>
						<AvRadioGroup name="mfaEnabled" label={local.TS_Enabled}>
							<AvRadio label={local.TS_Disabled} value={0} />
							<AvRadio label={local.TS_Enabled} value={1} />
						</AvRadioGroup>

						<legend>{local.TF_Allow_MFA_Bypass}</legend>

						{users && (
							<div className="MuiTable text-center">
								<MaterialTable
									columns={columns}
									data={users.filter((x) => userRole === "Eltek" || x.role !== "Eltek")}
									title=""
									icons={tableIcons}
									options={{
										padding: "dense",
										sorting: true,
										exportButton: false,
										paging: true,
										pageSize: 20,
										pageSizeOptions: [20, 50, 100],
										emptyRowsWhenPaging: false,
										headerStyle: {
											backgroundColor: "#fff",
											color: "#000",
										},
										rowStyle: {
											textAlign: "center",
										},
									}}
								/>
							</div>
						)}

						<div className="mt-2">
							<Button color="primary">{local.TS_Save_Changes}</Button>
							<Button onClick={() => cancel()} className="ml-2">
								{local.TS_Close}
							</Button>
						</div>
					</AvForm>
				)}
			</CardBody>
		</div>
	);
};

export default ConfigureMfa;
